<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :storageAdjustment="storageAdjustment"
        :isEdit="isEdit"
        :isLoss="isLoss"
        :originalEntry="originalEntry"
        :readOnly="readOnly"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null,
      originalEntry: null
    };
  },
  props: {
    entry: Object,
    storageAdjustment: Object,
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
    isLoss: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(loadEntry) {
      console.log("entry", this.entry);
      this.originalEntry = this.entry;
      this.editableEntry = _.cloneDeep(this.originalEntry);
      // console.log("ori entry", this.loadEntry);
      // console.log("load entry", loadEntry);
      // console.log("load entry", loadEntry, this.originalEntry, this.editableEntry)
      this.loading = true;
      // console.log("aqui");
       if (this.editableEntry.exitMovementItemLotsAttributes){
        this.$apollo
          .query({
            query: LOAD_EXTRAS_QUERY,
            variables: {
              storageId: this.storageAdjustment.storageId,
              itemId: this.originalEntry.item.id,
            },
            fetchPolicy: "no-cache"
          })
          .then(response => {
            // console.log("itens for stock adjustment", response);
            // this.entry.validations = response.data.accountContext.entryStorageAdjustmentItem.validations;
            // this.editableEntry.entryMovementItemLotsAttributes = response.data.accountContext.entryStorageAdjustmentItem.entryMovementItemLotsAttributes;
            this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
       }else if (this.storageAdjustment.isStockEntryType) {
        this.$apollo
          .query({
            query: LOAD_ENTRY_STORAGE_ADJUSTMENT_ITEM_QUERY,
            variables: {
              storageId: this.storageAdjustment.storageId,
              id: this.originalEntry.id,
            },
            fetchPolicy: "no-cache"
          })
          .then(response => {
            // console.log("itens for stock adjustment", response);
            this.entry.validations = response.data.accountContext.entryStorageAdjustmentItem.validations;
            this.editableEntry.entryMovementItemLotsAttributes = response.data.accountContext.entryStorageAdjustmentItem.entryMovementItemLotsAttributes;
            this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      } else {
        if(this.storageAdjustment.removeFromStorage){          
          this.$apollo
            .query({
              query: LOAD_EXIT_STORAGE_ADJUSTMENT_ITEM_QUERY,
              variables: {
                storageId: this.storageAdjustment.storageId,
                itemId: this.originalEntry.item.id,
                id: this.originalEntry.id,
              },
              fetchPolicy: "no-cache"
            })
            .then(response => {
              // console.log("itens for exit stock adjustment", response);
              this.entry.validations = response.data.accountContext.exitStorageAdjustmentItem.validations;
              console.log(this.editableEntry);
              this.editableEntry.exitMovementItemLotsAttributes = response.data.accountContext.exitStorageAdjustmentItem.exitMovementItemLotsAttributes;
              // console.log("response", this.editableEntry);
              this.extraData = response.data;
            })
            .catch(response => console.log(response))
            .finally(() => (this.loading = false));
          
        }else{
          this.$apollo
            .query({
              query: LOAD_DUMMY_EXIT_STORAGE_ADJUSTMENT_ITEM_QUERY,
              variables: {
                storageId: this.storageAdjustment.storageId,
                itemId: this.originalEntry.item.id,
                id: this.originalEntry.id,
              },
              fetchPolicy: "no-cache"
            })
            .then(response => {
              // console.log("itens for exit stock adjustment", response);
              this.entry.validations = response.data.accountContext.dummyExitStorageAdjustmentItem.validations;
              this.editableEntry.dummyExitMovementItemLotsAttributes = response.data.accountContext.dummyExitStorageAdjustmentItem.dummyExitMovementItemLotsAttributes;
              // console.log("response", this.editableEntry);
              this.extraData = response.data;
            })
            .catch(response => console.log(response))
            .finally(() => (this.loading = false));
        }
      }
      
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.pageLoading = true;
        Object.assign(this.originalEntry, this.editableEntry);
        console.log("entry update 123", this.editableEntry);
        this.pageLoading = false;
        this.$refs.baseEdit.closeDialog();
        this.$emit("entry-updated", this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_EXIT_STORAGE_ADJUSTMENT_ITEM_QUERY = gql `
  query($storageId: ID!, $itemId: ID!, $id: ID!) {
    accountContext {
      exitStorageAdjustmentItem(id: $id) {
        exitMovementItemLotsAttributes{
          id
          manufacturingLotId
          quantity
          packagingQuantity
          name
          dueDate
          manufacturingDate
        }
        validations
      }
      availableItemsForStorage(storageId: $storageId, itemId: $itemId) {
        id
        name
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        typeText
      }
    }
  }
`;

const LOAD_EXTRAS_QUERY = gql `
  query($storageId: ID!, $itemId: ID!) {
    accountContext {
      availableItemsForStorage(storageId: $storageId, itemId: $itemId) {
        id
        name
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        typeText
      }
    }
  }
`;

const LOAD_DUMMY_EXIT_STORAGE_ADJUSTMENT_ITEM_QUERY = gql `
  query($storageId: ID!, $itemId: ID!, $id: ID!) {
    accountContext {
      dummyExitStorageAdjustmentItem(id: $id) {
        dummyExitMovementItemLotsAttributes{
          id
          manufacturingLotId
          quantity
          packagingQuantity
          name
          dueDate
          manufacturingDate
        }
        validations
      }
      availableItemsForStorage(storageId: $storageId, itemId: $itemId) {
        id
        name
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        typeText
      }
    }
  }
`;

const LOAD_ENTRY_STORAGE_ADJUSTMENT_ITEM_QUERY = gql `
  query($storageId: ID!, $id: ID!) {
    accountContext {
      entryStorageAdjustmentItem(id: $id) {
        entryMovementItemLotsAttributes{
          id
          manufacturingLotId
          quantity
          packagingQuantity
          isNewLot
          name
          lotNumber
          dueDate
          manufacturingDate
        }
        validations
      }
      availableItemsForStorage(storageId: $storageId) {
        id
        name
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        typeText
      }
    }
  }
`;

</script>

<style scoped></style>
